<script>
import {Line} from 'vue-chartjs'
export default {
  extends: Line,
  data () {
    return {
      chartData: {
        labels: ["Jan",	"Feb",	"Mar",	"Apr",	"May",	"Jun",	"Jul", "Aug"],
        datasets: [
          {
            label: 'Line Chart',
            data: [600,	1150,	342, 1650,	1522,	1000,	1259,	157],
            fill: false,
            borderColor: '#602f6b',
            backgroundColor: '#602f6b',
            borderWidth: 1,
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>